import SxQueryUtils from "../../sxQuery/SxQueryUtils";
const COOKIE_LIFETIME = 20 * 365;
const createCookieName = (accountId, environment) => {
    if ((accountId || '').trim().length === 0 || (environment || '').trim().length === 0) {
        return undefined;
    }
    return `zoovu-opt-out-${environment}-${accountId}`;
};
export default {
    isOptOut(configuration) {
        const { zoovuAccountId, zoovuEnvironment } = configuration;
        const cookieName = createCookieName(zoovuAccountId, zoovuEnvironment);
        if (cookieName) {
            const cookieValue = SxQueryUtils.readCookie(cookieName);
            if (cookieValue === undefined || cookieValue === null) {
                return configuration.tracking.optOutDefault;
            }
            return cookieValue === 'true';
        }
        return false;
    },
    exposeTrackingMethods(context) {
        if ('ZoovuTracking' in window) {
            return;
        }
        const { zoovuAccountId, zoovuEnvironment } = context.pluginConfiguration;
        const cookieName = createCookieName(zoovuAccountId, zoovuEnvironment);
        if (cookieName) {
            window.ZoovuTracking = {
                optOut() {
                    SxQueryUtils.createCookie('ssi--sessionId', '', -1);
                    SxQueryUtils.createCookie('ssi--lastInteraction', '', -1);
                    SxQueryUtils.createCookie(cookieName, 'true', COOKIE_LIFETIME);
                    context.disableInsights();
                },
                optIn() {
                    SxQueryUtils.createCookie(cookieName, 'false', COOKIE_LIFETIME);
                    if (context.pluginConfiguration.tracking.logQueries) {
                        context.createInsights();
                    }
                }
            };
        }
    }
};
